export default "__VITE_ASSET__DpOP0Th9__"